import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pluralization',
  standalone: true,
})
export class PluralizationPipe implements PipeTransform {
  transform(count: number): 'zero' | 'one' | 'other' {
    if (count === 0) return 'zero';
    if (count === 1) return 'one';
    return 'other';
  }
}
